"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var TagInput = function TagInput(props) {
  var field = props.field,
    form = props.form,
    label = props.label,
    availableTags = props.availableTags;
  var defaultValue = field.value || [];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", null, label), /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], {
    defaultValue: defaultValue,
    data: availableTags,
    value: field.value || [],
    allowCreate: true,
    onCreate: function onCreate(item) {
      if ((field.value || []).includes(item)) {
        return;
      }
      form.setFieldValue(field.name, [].concat(_toConsumableArray(field.value || []), [item]));
    },
    onChange: function onChange(selections) {
      form.setFieldValue(field.name, selections);
    }
  }));
};
TagInput.propTypes = {
  form: _propTypes["default"].object,
  field: _propTypes["default"].object,
  label: _propTypes["default"].node,
  availableTags: _propTypes["default"].array
};
TagInput.defaultProps = {
  availableTags: []
};
var _default = TagInput;
exports["default"] = _default;